import React from "react";
import querystring from "querystring-es3";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { organizationURLStyle, organizationAPIStyle } from "util/organization";
import organizationViewStateToProps from "../selectors";
import * as actions from "../actions";
import OrganizationLayout from "./OrganizationLayout";

class OrganizationView extends React.Component {
  static propTypes = {
    workarea: PropTypes.string,
    organization: PropTypes.string,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired,
    actions: PropTypes.shape({
      setOrganization: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    workarea: "",
    organization: ""
  };

  componentDidMount() {
    const search = this.props.location.search.replace("?", "");
    const query = querystring.parse(search);
    if (
      query.organization &&
      organizationAPIStyle(query.organization) !== this.props.organization
    ) {
      this.props.actions.setOrganization(
        organizationAPIStyle(query.organization)
      );
    }
  }

  updateQueryAndRedirect(organization) {
    const {
      location: { pathname },
      history: { push }
    } = this.props;

    const search = this.props.location.search.replace("?", "");
    const query = querystring.parse(search);

    const defaultNext =
      pathname === "/portal2/organization" ? "/portal2/ctd" : pathname;
    const { next = defaultNext, workarea = this.props.workarea } = query;
    if (workarea) {
      push(`${next}?workarea=${workarea}&organization=${organization}`);
    } else {
      push(`${next}?organization=${organization}`);
    }
  }

  handleSelectOrganization(nextOrganization) {
    if (this.props.organization !== nextOrganization) {
      this.props.actions.setOrganization(nextOrganization);
    }
    this.updateQueryAndRedirect(organizationURLStyle(nextOrganization));
  }

  render() {
    return (
      <OrganizationLayout
        {...this.props}
        onSelectOrganization={organization =>
          this.handleSelectOrganization(organization)
        }
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(organizationViewStateToProps, mapDispatchToProps)(OrganizationView)
);
